import React from 'react';
import { AutoSaveStatus } from 'components/AutoSaveStatus';
import { useMutationState } from '@tanstack/react-query';
import {
  UPDATE_CUSTOM_FIELD_ELEVE_KEY,
  UPDATE_ELEVE_KEY,
} from 'queries/eleves/useUpdateEleve';

function useSaveStatus() {
  const updateEleveStatuses = useMutationState({
    filters: { mutationKey: [UPDATE_ELEVE_KEY] },
    select: mutation => mutation.state.status,
  });

  const updateCustomFieldsStatus = useMutationState({
    filters: { mutationKey: [UPDATE_CUSTOM_FIELD_ELEVE_KEY] },
    select: mutation => mutation.state.status,
  });

  const matching = [...updateCustomFieldsStatus, ...updateEleveStatuses].find(
    s => s === 'pending',
  );
  if (matching) return 'saving';
  return 'saved';
}

export function SaveStatus() {
  const status = useSaveStatus();

  return <AutoSaveStatus status={status} />;
}
